export type AddressType = 'PERSONAL_ADDRESS' | 'PREVIOUS_ADDRESS';

export type TimeAtAddress = {
    years: number;
    months: number;
};

export type ExtendedAddress = Address & {
    city: string;
    type: AddressType;
    timeAtAddress: TimeAtAddress;
};

export type Address = {
    county: string;
    country: string;
    eircode: string;
    townOrCity: string;
    addressLine1: string;
    addressLine2: string;
};

type Vat = {
    vatRegistered: boolean;
    vatNumber: string;
    vatVerified: boolean;
};

type AboutBusiness = {
    businessType: string;
    legalCompanyName: string;
    website: string;
    registeredNumber: string;
    tradingName: string;
    isCharity: boolean;
    charityNumber: string;
    registeredAddress: Address;
    vat: Vat;
};

type SiteContact = {
    firstName: string;
    lastName: string;
    email: string;
    mobileNumber: string;
    telephoneNumber: string;
    position: string;
};

export enum ServiceChargeCalculatedAt {
    GROUPLEVEL = 'GROUPLEVEL',
    COMPANYLEVEL = 'COMPANYLEVEL',
    OUTLETLEVEL = 'OUTLETLEVEL',
}

type BankingDetails = {
    serviceChargeCalculatedAt: ServiceChargeCalculatedAt;
    bankIdentifierCode?: string;
    internationalBankAccountNumber?: string;
    accountName?: string;
};

export type Outlet = {
    name: string;
    tradingAddress: Address;
    siteContact: SiteContact;
    bankingDetails: BankingDetails;
};

export type MerchantInformation_FormValues = {
    aboutBusiness: AboutBusiness;
    outlets: Outlet[];
    sameAsRegisteredAddress: boolean;
    numberOfOutlets: number;

    principalPersonalAddress_eircode: string;
    principalPersonalAddress_addressLine1: string;
    principalPersonalAddress_addressLine2: string;
    principalPersonalAddress_townOrCity: string;
    principalPersonalAddress_county: string;
    principalPersonalAddress_country: string;
    principalPersonalAddress_timeAtAddress: string;
    principalPreviousAddress_eircode: string;
    principalPreviousAddress_addressLine1: string;
    principalPreviousAddress_addressLine2: string;
    principalPreviousAddress_townOrCity: string;
    principalPreviousAddress_county: string;
    principalPreviousAddress_country: string;
    principalPreviousAddress_timeAtAddressYears: number;
    principalPreviousAddress_timeAtAddressMonths: number;
    principalPersonalAddress_timeAtAddressYears: number;
    principalPersonalAddress_timeAtAddressMonths: number;
};

export type Principal = {
    email: string;
    title: string;
    lastName: string;
    position: string;
    addresses: ExtendedAddress[];
    firstName: string;
    dateOfBirth: string;
    middleNames: string;
    nationality: string;
    mobileNumber: string;
    telephoneNumber: string;
    isBeneficialOwner: boolean;
    percentageOfOwnership: number;
    isBillingContact: boolean;
};
